"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var GeodesPreview23_exports = {};
__export(GeodesPreview23_exports, {
  default: () => GeodesPreview23_default
});
module.exports = __toCommonJS(GeodesPreview23_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M12.9414 8.64844C13.0326 8.73958 13.0781 8.85677 13.0781 9C13.0781 9.14323 13.0326 9.26042 12.9414 9.35156L11.2031 11.0898L12.9414 12.8086C13.0326 12.9128 13.0781 13.0365 13.0781 13.1797C13.0781 13.3099 13.0326 13.4206 12.9414 13.5117C12.8372 13.6159 12.7135 13.668 12.5703 13.668C12.4401 13.668 12.3294 13.6159 12.2383 13.5117L10.5 11.793L8.76172 13.5117C8.67057 13.6159 8.55339 13.668 8.41016 13.668C8.27995 13.668 8.16276 13.6159 8.05859 13.5117C7.96745 13.4206 7.92188 13.3099 7.92188 13.1797C7.92188 13.0365 7.96745 12.9128 8.05859 12.8086L9.79688 11.0898L8.05859 9.35156C7.96745 9.26042 7.92188 9.14323 7.92188 9C7.92188 8.85677 7.96745 8.73958 8.05859 8.64844C8.16276 8.54427 8.27995 8.49219 8.41016 8.49219C8.55339 8.49219 8.67057 8.54427 8.76172 8.64844L10.5 10.3672L12.2383 8.64844C12.3294 8.54427 12.4401 8.49219 12.5703 8.49219C12.7135 8.49219 12.8372 8.54427 12.9414 8.64844ZM7.16016 3.16016C7.16016 2.82161 7.28385 2.52865 7.53125 2.28125C7.77865 2.03385 8.07161 1.91016 8.41016 1.91016H12.5898C12.9284 1.91016 13.2214 2.03385 13.4688 2.28125C13.7161 2.52865 13.8398 2.82161 13.8398 3.16016H15.5C15.9557 3.16016 16.3464 3.32292 16.6719 3.64844C16.9974 3.97396 17.1602 4.37109 17.1602 4.83984V16.5C17.1602 16.9557 16.9974 17.3464 16.6719 17.6719C16.3464 17.9974 15.9557 18.1602 15.5 18.1602H5.5C5.04427 18.1602 4.65365 17.9974 4.32812 17.6719C4.0026 17.3464 3.83984 16.9557 3.83984 16.5V4.83984C3.83984 4.37109 4.0026 3.97396 4.32812 3.64844C4.65365 3.32292 5.04427 3.16016 5.5 3.16016H7.16016ZM12.8242 3.16016V4C12.8242 4.0651 12.7982 4.1237 12.7461 4.17578C12.707 4.22786 12.6549 4.25391 12.5898 4.25391H8.41016C8.34505 4.25391 8.28646 4.22786 8.23438 4.17578C8.19531 4.1237 8.17578 4.0651 8.17578 4V3.16016C8.17578 3.09505 8.19531 3.04297 8.23438 3.00391C8.28646 2.95182 8.34505 2.92578 8.41016 2.92578H12.5898C12.6549 2.92578 12.707 2.95182 12.7461 3.00391C12.7982 3.04297 12.8242 3.09505 12.8242 3.16016ZM13.8203 4.17578C13.7812 4.47526 13.6445 4.72917 13.4102 4.9375C13.1758 5.14583 12.9023 5.25 12.5898 5.25H8.41016C8.09766 5.25 7.82422 5.14583 7.58984 4.9375C7.35547 4.72917 7.21875 4.47526 7.17969 4.17578H5.5C5.31771 4.17578 5.16146 4.24089 5.03125 4.37109C4.90104 4.5013 4.83594 4.65755 4.83594 4.83984V16.5C4.83594 16.6823 4.90104 16.8385 5.03125 16.9688C5.16146 17.099 5.31771 17.1641 5.5 17.1641H15.5C15.6823 17.1641 15.8385 17.099 15.9688 16.9688C16.099 16.8385 16.1641 16.6823 16.1641 16.5V4.83984C16.1641 4.65755 16.099 4.5013 15.9688 4.37109C15.8385 4.24089 15.6823 4.17578 15.5 4.17578H13.8203Z",
      fill: "currentColor"
    }
  )
);
const SvgGeodesPreview23 = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var GeodesPreview23_default = SvgGeodesPreview23;
